/**
 * ReReportedBadge — compact amber "↻ RR" chip shown beside a study's status
 * when the study has been re-reported (order_workflow.ow_re_reported).
 *
 * Replaces the old bare "RR" text: it reads as a graphic indicator (in the same
 * flat-color spirit as the ActionIcons set) and carries a tooltip, since "RR" is
 * internal jargon. Kept intentionally narrow so it still fits next to the status
 * pill inside the constrained, sticky status column.
 */
import React from 'react';
import { Tooltip } from 'antd';
import { RedoOutlined } from '@ant-design/icons';

export const ReReportedBadge: React.FC = () => (
  <Tooltip title="Re-reported">
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2px',
        height: '20px',
        padding: '0 6px',
        borderRadius: '10px',
        background: '#F5EFE2',
        color: '#8A6A2E',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        fontSize: '11px',
        lineHeight: '20px',
        letterSpacing: '0.04px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      <RedoOutlined style={{ fontSize: '11px' }} />
      RR
    </span>
  </Tooltip>
);

export default ReReportedBadge;
